import { Row } from "reactstrap"

const NominationAccreditationPreview = props => {
  return (
    <>
      <Row>
        <h5>Application Details</h5>
        <table className="table table-striped table-responsive">
          <thead>
            <tr>
              <th>Item</th>
              <th>Value</th>
            </tr>
          </thead>

          <tbody>
            <tr>
              <td> Legal Status </td>
              <td>{props.data.legal_status}</td>
            </tr>

            <tr>
              <td>Nomination Approach</td>
              <td>{props.data.nomination_approach}</td>
            </tr>
            {props.data.access_entity_type ? (
              <tr>
                <td>Access Entity Type</td>
                <td>{props.data.access_entity_type}</td>
              </tr>
            ) : null}
<tr>
              <td>Project Name</td>
              <td>{props.data.project_name}</td>
            </tr>
            <tr>
              <td>Project Description</td>
              <td>{props.data.project_description}</td>
            </tr>
            <tr>
              <td>Alignment to Mandate</td>
              <td>{props.data.alignment_to_mandate}</td>
            </tr>

            {/* <tr>
              <td>Request Details</td>
              <td>{props.data.request_details}</td>
            </tr> */}
          </tbody>
        </table>
      </Row>
    </>
  )
}

export default NominationAccreditationPreview
